import { useState, useEffect } from 'react';
import 'animate.css';
import './Noticebanner.css';

const NoticeBanner = () => {

  const [show, setShow] = useState(true)

  useEffect(() => {
    setShow(JSON.parse(window.sessionStorage.getItem("show")));
  }, []);


useEffect(() => {
    window.sessionStorage.setItem("show", show);
  }, [show]);


  let Banner = () => {


    return (

      <div>
        <div className="animate__animated animate__slideInDown wrapper bg-info responsive-banner">

          <div className="pt-3">

            <div className="row">


              <div className="col ml-3 responsive-banner"> 
             <p> Course Limited-time offer. <a className="text-light" href="https://www.udemy.com/course/aws-certified-cloud-practitioner-2021-new/?couponCode=D50429379876AF23312E">Learn about AWS Cloud!</a> 💻☁️</p>
              </div>
              <div className="col responsive-banner"><a className="text-light float-right mr-5" onClick={() => setShow(!show)} > <b>X</b></a>
              </div>

            </div>
            <div/>
          </div>



        </div>
      </div>




    )

  }


  return (

    <div>
      {!show ? <Banner /> : null}

    </div>

  )

}

export default NoticeBanner;
